import React from 'react';
import "../template-file-css/document-file-template.css";


export const GENERAL_MedicationConsentChild = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GENERAL_MedicationConsentChild' className='file-pdf-document'>
            <div className='file-template'>



                <h3>PART A- To be completed by Physician prescribing the medication</h3>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name of Physician</span>
                            <input type="text" id="txtNameOfPhysician" name="txtNameOfPhysician" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Physician Contact Number</span>
                            <input type="text" id="txtPhysicianContactNumber" name="txtPhysicianContactNumber" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Physician Email</span>
                            <input type="text" id="txtPhysicianEmail" name="txtPhysicianEmail" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name of the Child</span>
                            <input type="text" id="txtNameOfTheChild" name="txtNameOfTheChild" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Chils's Date of Birth(Month, Day, Year)</span>
                            <input type="date" id="txtChildDate" name="txtChildDate" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Reason for Request</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbNewMedication" name="cbNewMedication" className='add-only' value="1" /> New Medication
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbNotificationEmergency" name="cbNotificationEmergency" className='add-only' value="1" /> Notification of Emergency Use
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbCurrentMedication" name="cbCurrentMedication" className='add-only' value="1" /> Continue Current Medication Only
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbReason_Other" name="cbReason_Other" className='add-only' value="1" /> Other: &nbsp;
                            <input type="text" id="txtReason_Other" name="txtReason_Other" className='add-only w-150' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Allergies/Adverse Reactions</span>
                    <input type="checkbox" id="cbNKDA" name="cbNKDA" className='add-only' value="1" /> NKDA
                </p>
                <p className='w-750'>
                    <textarea id="txtAllergies" name="txtAllergies" className='add-only'></textarea>

                </p>
                <h3>DSM-5 Diagnoses</h3>
                <p className='w-750'>
                    <span className='eleHeader'>AXIS I</span>
                    <textarea id="txtAXISI" name="txtAXISI" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>AXIS II</span>
                    <textarea id="txtAXISII" name="txtAXISII" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>AXIS III</span>
                    <textarea id="txtAXISIII" name="txtAXISIII" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Current psychotropic Medications, including PRN and Medications including dose, schedule and route</span>
                    <textarea id="txtCurrentPsychotropic" name="txtCurrentPsychotropic" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Current Non-Psychotropic Medications, including nutritional supplements</span>
                    <textarea id="txtCurrentNonPsychotropic" name="txtCurrentNonPsychotropic" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Was the child given unauthorized medications due to an emergency?</span>
                    <input type="radio" id="rbEmergency_Yes" name="rbEmergency" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbEmergency_No" name="rbEmergency" className='add-only' value="No" /> No
                </p>
                <p className='w-750'>
                    <span> If yes, please explain the situation below and list all medications given to the child, as well all other interventions that were attempted.</span>
                </p>
                <p className='w-750'>
                    <textarea id="txtEnergency_YesNo" name="txtEnergency_YesNo" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-190'><span className='eleHeader'>Recommended Medication</span></td>
                        <td className='w-70'><span className='eleHeader'>Dosage</span></td>
                        <td className='w-60'><span className='eleHeader'>Route</span></td>
                        <td className='w-140'><span className='eleHeader'>Range of Dosage</span></td>
                        <td className='w-140'><span className='eleHeader'>Target Symptoms</span></td>
                        <td className='w-150'>
                            <span className='eleHeader'>  Duration <span className='small'> (*30, 60, 90 days) </span></span>

                        </td>
                    </tr>
                    <tr>
                        <td className='w-190'>
                            <input type='text' id="txtRecommendedMedication_1" name="txtRecommendedMedication_1" className='add-only' /></td>
                        <td className='w-70'>
                            <input type='text' id="txtDosage_1" name="txtDosage_1" className='add-only' /></td>
                        <td className='w-60'>
                            <input type='text' id="txtRoute_1" name="txtRoute_1" className='add-only' /></td>
                        <td className='w-140'>
                            <input type='text' id="txtRangeOfDosage_1" name="txtRangeOfDosage_1" className='add-only' /></td>
                        <td className='w-140'>
                            <input type='text' id="txtTargetSymptoms_1" name="txtTargetSymptoms_1" className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id="txtDuration_1" name="txtDuration_1" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-190'>
                            <input type='text' id="txtRecommendedMedication_2" name="txtRecommendedMedication_2" className='add-only' /></td>
                        <td className='w-70'>
                            <input type='text' id="txtDosage_2" name="txtDosage_2" className='add-only' /></td>
                        <td className='w-60'>
                            <input type='text' id="txtRoute_2" name="txtRoute_2" className='add-only' /></td>
                        <td className='w-140'>
                            <input type='text' id="txtRangeOfDosage_2" name="txtRangeOfDosage_2" className='add-only' /></td>
                        <td className='w-140'>
                            <input type='text' id="txtTargetSymptoms_2" name="txtTargetSymptoms_2" className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id="txtDuration_2" name="txtDuration_2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-190'>
                            <input type='text' id="txtRecommendedMedication_3" name="txtRecommendedMedication_3" className='add-only' /></td>
                        <td className='w-70'>
                            <input type='text' id="txtDosage_3" name="txtDosage_3" className='add-only' /></td>
                        <td className='w-60'>
                            <input type='text' id="txtRoute_3" name="txtRoute_3" className='add-only' /></td>
                        <td className='w-140'>
                            <input type='text' id="txtRangeOfDosage_3" name="txtRangeOfDosage_3" className='add-only' /></td>
                        <td className='w-140'>
                            <input type='text' id="txtTargetSymptoms_3" name="txtTargetSymptoms_3" className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id="txtDuration_3" name="txtDuration_3" className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <strong>Please attach a list of all potential side effects and/or adverse reactions for each medication listed above.</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Lab studies, Blood Work, per protocol or other follow up needed</span>
                            <input type="radio" id="rbLabStudies_Yes" name="rbLabStudies" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbLabStudies_No" name="rbLabStudies" className='add-only' value="No" /> No
                        </td>
                    </tr> 
                    <tr>
                        <td className='w-100'>
                            <input type="checkbox" id="cbLithium" name="cbLithium" className='add-only' value="1" /> Lithium
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbEKG" name="cbEKG" className='add-only' value="1" /> EKG
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbVPA" name="cbVPA" className='add-only' value="1" /> VPA
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbEEG" name="cbEEG" className='add-only' value="1" /> EEG
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbTegretol" name="cbTegretol" className='add-only' value="1" /> Tegretol
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbCTMRI" name="cbCTMRI" className='add-only' value="1" /> CT/MRI
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type="checkbox" id="cbOther" name="cbOther" className='add-only' value="1" /> Other:
                            <input type="text" id="txtOther" name="txtOther" className='add-only w-250' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Explain as needed</span>
                    <textarea id="txtExplainNeeded" name="txtExplainNeeded" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Please explain how the medications listed above interact with other medications the child takes</span>
                    <textarea id="txtMedicationsListed" name="txtMedicationsListed" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Please explain what alternate treatment options are available</span>
                    <textarea id="txtAlternateTreatment" name="txtAlternateTreatment" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Please explain what additional treatment will be used, i.e. individual counseling, group therapy, etc.</span>
                    <textarea id="txtAdditionalTreatment" name="txtAdditionalTreatment" className='add-only'></textarea>
                </p>
                <p className='w-750'><strong>Georgia Department of Human ServicesDepartment of Family & Children Services (DFCS)Authorization of Psychotropic Medication for Children in Foster CareBy signing below, I certify that the above information is true to the best of my knowledge</strong></p>
                <table>
                    <tr>
                        <td className='signature w-550'>&nbsp;</td>
                        <td className='signature w-200'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small  w-550'>Signature Of Physician</td>
                        <td className='small  w-200'>Date (Month, Day, Year)</td>
                    </tr>
                </table>
                <h3>PART B-To be completed by the DFCS local director or designee (CHECK ALL THAT APPLY)</h3>
                <p className='w-750'>
                    <input type="checkbox" id="cbGiveMyConsent" name="cbGiveMyConsent" className='add-only' value="1" /> By signing below, I give my consent for <input type="text" id="txtGiveMyConsent" placeholder="Name of Child" name="txtGiveMyConsent" className='add-only' /> to take the medication(s) listed above as prescribed by his/her physician.
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="cbGiveMyNotConsent" name="cbGiveMyNotConsent" className='add-only' value="1" /> By signing below, I do not give my consent for <input type="text" id="txtGiveMyNotConsent" placeholder="Name of Child" name="txtGiveMyNotConsent" className='add-only' /> to take the medication(s) listed above as prescribed by his/her physician.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Reason consent not given at this time</span>
                    <textarea id="txtReasonConsent" name="txtReasonConsent" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='signature w-550'>&nbsp;</td>
                        <td className='signature w-200'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-550">Signature of local DFCS County Director/Designee</td>
                        <td className="small w-200">Date (Month, Day, Year)</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>County</span>
                            <input type="text" id="txtCounty" name="txtCounty" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>DFCS Region</span>
                            <input type="text" id="txtDFCSRegion" name="txtDFCSRegion" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Contact Number</span>
                            <input type="text" id="txtContactNumber" name="txtContactNumber" className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <strong>For Fulton & Dekalb Counties:</strong>
                </p>
                <p className='w-750'>Email:TOM.FORTINGO@DHS.GA.GOV</p>
                <p className='w-750'>Fax: (404-307-5499)</p>

            </div>
        </form>
    )
}